import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import Iconify from '../iconify/Iconify';

function CustomCompleteWorksheets({
  placeholder, 
  propVal, 
  option, 
  childFuc, 
  fetch, 
  fullVal, 
  helperText, 
  err, 
  req, 
  cityStateStyling1
}) {
  const [selectedVal, setSelectedVal] = useState('');
  const [dropdown, setDropdown] = useState(false);
  const [localOption, setLocalOption] = useState([]);

  useEffect(() => {
    if (localOption.length > 0) setDropdown(true);
    else setDropdown(false);
    setSelectedVal(propVal);
  }, []);

  useEffect(() => {
    setLocalOption(option);
  }, [option]);

  useEffect(() => {
    setSelectedVal(propVal);
  }, [propVal]);

  const fetchValue = (e) => {
    setDropdown(true);
    setSelectedVal(e.target.value);
    childFuc(e.target.value);
    if (e.target.value.length === 0) {
      setDropdown(false);
    }
  };

  const setValue = (e) => {
    if (fetch === 'state') {
      const csc = `${e.item.city} ${e.item.state}`;
      setDropdown(false);
      setSelectedVal(csc);
      childFuc(e.item);
      fullVal(e.item);
    } else {
      setDropdown(false);
      childFuc(e.item);
      fullVal(e.item);
      setSelectedVal(e.item);
    }
  };

  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        <TextField
          required={req}
          size={cityStateStyling1 ? "small" : "large"}
          error={err}
          helperText={err?helperText:""}
          id="outlined-multiline-static"
          label={placeholder || ''}
          rows={4}
          autoComplete="off"
          onChange={(e) => fetchValue(e)}
          sx={{ width: '100%' }}
          InputLabelProps={{ shrink: true }}
          value={selectedVal}
        />
      </div>

      {dropdown && (
        <div
          style={{
            position: 'absolute', 
            top: '35%', 
            left: "64%",
            width: '35%', 
            maxHeight: 100, 
            overflowY: 'scroll', 
            backgroundColor: 'white', 
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)', 
            cursor: 'pointer',
            zIndex: 9999, 
          }}
        >
          {localOption.map((item) => (
            <Typography
              key={fetch === 'state' ? (item?.zip || item?.postal) : item}
              sx={{
                padding: 1,
                '&:hover': {
                  backgroundColor: '#f1f1f1', 
                },
              }}
              onClick={() => setValue({ item })}
            >
              {fetch === 'state' 
                ? `${item?.city} (${item?.state}) (${item?.zip || item?.postal})` 
                : item}
            </Typography>
          ))}
        </div>
      )}
    </>
  );
}

export default CustomCompleteWorksheets;
